// extracted by extract-css-chunks-webpack-plugin
module.exports = {"layout":"main__layout--34iNZ","wrapper":"main__wrapper--1rrC1","sidebar":"main__sidebar--TKFIX","main":"main__main--1iPs-"};